module.exports = __webpack_public_path__ + "media/images/input_state_icon/scream-6d327f029bbef345e6220e021b7233ba.svg";